import React from 'react';
import { GenericFormModal } from './GenericFormModal';
import { ColorFormFields } from '../forms/ColorFormFields';

export function ColorFormModal({ 
  isOpen, 
  onClose, 
  color,
  onSubmit
}) {
  const [localFormData, setLocalFormData] = React.useState(color || {
    name_de: '',
    name_en: '',
    color_code: '#000000'
  });

  // Update localFormData when color prop changes
  React.useEffect(() => {
    if (color) {
      setLocalFormData(color);
    } else {
      setLocalFormData({
        name_de: '',
        name_en: '',
        color_code: '#000000'
      });
    }
  }, [color, isOpen]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setLocalFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(e, localFormData);
      onClose();
    } catch (error) {
      console.error('ColorFormModal submit error:', error);
      // Modal bleibt offen bei Fehler
    }
  };

  return (
    <GenericFormModal 
      isOpen={isOpen} 
      onClose={onClose}
      title={color ? 'Farbe bearbeiten' : 'Neue Farbe'}
      size="xl"
    >
      <ColorFormFields
        formData={localFormData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isEdit={!!color}
      />
    </GenericFormModal>
  );
}